import { FileUploadFormField } from '@/components/form/file-upload-form-field'
import {
  AVATAR_IMAGE_OPTIMIZATION,
  IMAGE_UPLOAD_LIMITS,
  useImageUploadErrorToast,
} from '@/components/ui/file-upload'

const AVATAR_ACCEPTED_TYPES = ['JPG', 'JPEG', 'PNG']

interface AvatarFormFieldProps {
  existingImageUrl?: string
  label: string
  name?: string
  uploadLabel: string
}

export const AvatarFormField = ({
  existingImageUrl,
  label,
  name = 'avatar',
  uploadLabel,
}: AvatarFormFieldProps) => {
  const handleValidationError = useImageUploadErrorToast({
    acceptedTypes: AVATAR_ACCEPTED_TYPES,
    ...IMAGE_UPLOAD_LIMITS,
  })

  return (
    <FileUploadFormField
      withReservedFooter
      name={name}
      acceptedTypes={AVATAR_ACCEPTED_TYPES}
      {...IMAGE_UPLOAD_LIMITS}
      existingImageUrl={existingImageUrl}
      imageOptimization={AVATAR_IMAGE_OPTIMIZATION}
      label={label}
      layout="maximized"
      maxFiles={1}
      multiple={false}
      uploadLabel={uploadLabel}
      onValidationError={handleValidationError}
    />
  )
}
